(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-symk-carousel]').forEach(function (root) {
      var viewport = root.querySelector('[data-carousel-viewport]');
      var track = root.querySelector('[data-carousel-track]');
      if (!viewport || !track) return;

      var items = Array.prototype.filter.call(track.children, function (el) {
        return el.classList.contains('symk-best__item');
      });
      if (!items.length) return;

      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      // Start focused on the middle of the first visible trio.
      var active = Math.min(1, items.length - 1);

      function update() {
        var item = items[active];
        var offset = viewport.clientWidth / 2 - (item.offsetLeft + item.offsetWidth / 2);
        track.style.transform = 'translateX(' + offset + 'px)';
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === items.length - 1;
      }
      function go(dir) {
        active = Math.max(0, Math.min(items.length - 1, active + dir));
        update();
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      // Clicking a side bottle focuses it instead of following its link.
      items.forEach(function (el, i) {
        el.addEventListener('click', function (e) {
          if (i !== active) { e.preventDefault(); active = i; update(); }
        });
      });

      window.addEventListener('resize', update);
      update();
      window.requestAnimationFrame(update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-symk-filter]').forEach(function (root) {
      var toggle = root.querySelector('[data-symk-filter-toggle]');
      var panel = root.querySelector('.symk-coll__filters');
      if (!toggle || !panel) return;
      toggle.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
        toggle.setAttribute('aria-expanded', String(open));
      });
    });

    // AJAX "See more" — fetch the next page, append its product cells, and
    // update the count/link in place so the grid grows without a reload.
    document.querySelectorAll('.symk-coll__listing').forEach(function (listing) {
      var grid = listing.querySelector('[data-symk-grid]');
      var footer = listing.querySelector('[data-symk-footer]');
      if (!grid || !footer) return;

      function bindMore() {
        var link = footer.querySelector('[data-symk-loadmore]');
        if (!link) return;

        link.addEventListener('click', function (e) {
          e.preventDefault();
          if (link.getAttribute('aria-busy') === 'true') return;

          var url = link.getAttribute('href');
          if (!url) return;

          var label = link.querySelector('[data-symk-loadmore-label]') || link;
          var prevText = label.textContent;
          link.setAttribute('aria-busy', 'true');
          link.classList.add('is-loading');
          label.textContent = '…';

          fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (res) {
              if (!res.ok) throw new Error('Request failed: ' + res.status);
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-symk-grid]');
              var firstNew = null;

              if (newGrid) {
                var cells = newGrid.querySelectorAll('.symk-coll__cell');
                for (var i = 0; i < cells.length; i++) {
                  var cell = document.importNode(cells[i], true);
                  if (i === 0) firstNew = cell;
                  grid.appendChild(cell);
                }
              }

              // Pull in the refreshed count + next link from the fetched footer.
              var newFooter = doc.querySelector('[data-symk-footer]');
              var newCount = newFooter && newFooter.querySelector('[data-symk-count]');
              var curCount = footer.querySelector('[data-symk-count]');
              if (newCount && curCount) {
                curCount.textContent = newCount.textContent.trim();
              }

              var newLink = newFooter && newFooter.querySelector('[data-symk-loadmore]');
              if (newLink) {
                // More pages remain — point the button at the next URL.
                link.setAttribute('href', newLink.getAttribute('href'));
                link.removeAttribute('aria-busy');
                link.classList.remove('is-loading');
                label.textContent = prevText;
              } else {
                // No more pages — retire the button.
                link.remove();
              }

              // Update the browser URL without reloading, so refresh/back behave.
              if (window.history && window.history.replaceState) {
                window.history.replaceState({}, '', url);
              }

              // Move focus to the first newly added card for keyboard users.
              if (firstNew) {
                var focusable = firstNew.querySelector('a, button');
                if (focusable) {
                  focusable.setAttribute('tabindex', '-1');
                  focusable.focus();
                }
              }
            })
            .catch(function () {
              // On failure, restore the link so the user can retry / fall back.
              link.removeAttribute('aria-busy');
              link.classList.remove('is-loading');
              label.textContent = prevText;
              window.location.href = url;
            });
        });
      }

      bindMore();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 300;
    var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(item) {
      if (item.__symkFaqBound || !item.animate) return;
      item.__symkFaqBound = true;

      var summary = item.querySelector('.symk-faq__q');
      var content = item.querySelector('.symk-faq__a');
      if (!summary) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      function settle(open) {
        item.open = open;
        animation = null;
        isClosing = false;
        isExpanding = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      function animateTo(startHeight, endHeight, open) {
        if (animation) animation.cancel();
        animation = item.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = function () { settle(open); };
        animation.oncancel = function () { isClosing = false; isExpanding = false; };
      }

      function expand() {
        isExpanding = true;
        var start = item.offsetHeight;
        var end = summary.offsetHeight + (content ? content.offsetHeight : 0);
        animateTo(start, end, true);
      }

      function open() {
        item.style.height = item.offsetHeight + 'px';
        item.open = true;
        window.requestAnimationFrame(expand);
      }

      function shrink() {
        isClosing = true;
        animateTo(item.offsetHeight, summary.offsetHeight, false);
      }

      summary.addEventListener('click', function (e) {
        if (reduce.matches) return; // let the browser toggle instantly
        e.preventDefault();
        item.style.overflow = 'hidden';
        if (isClosing || !item.open) {
          open();
        } else if (isExpanding || item.open) {
          shrink();
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.symk-faq__item').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Re-bind when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-symk-header]').forEach(function (header) {
      var openBtn = header.querySelector('[data-menu-open]');
      if (!openBtn) return;
      var drawer = document.getElementById(openBtn.getAttribute('aria-controls'));
      if (!drawer) return;

      function open() {
        drawer.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      }
      function close() {
        drawer.hidden = true;
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        openBtn.focus();
      }
      openBtn.addEventListener('click', open);
      drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) close();
      });
    });
  })();

  // Reflect the saved-item count on the header wishlist link.
  (function () {
    var counts = document.querySelectorAll('[data-wishlist-count]');
    if (!counts.length) return;
    function update(items) {
      var n = items ? items.length : 0;
      counts.forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }
    document.addEventListener('symk:wishlist:change', function (e) {
      update((e.detail && e.detail.items) || (window.SymkWishlist ? window.SymkWishlist.items() : []));
    });
    if (window.SymkWishlist) update(window.SymkWishlist.items());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-symk-hero]').forEach(function (hero) {
      var track = hero.querySelector('[data-hero-track]');
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      var n = slides.length;
      if (!track || n < 2) {
        // Single slide: arrows have nothing to navigate.
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;

      // Endless loop: bookend the real slides with edge clones so the track reads
      // [cloneLast, real0..realN-1, cloneFirst]. Scrolling onto a clone settles, then
      // jumps (instantly) to its real twin — so it keeps going either way, no rewind.
      function makeClone(node) {
        var c = node.cloneNode(true);
        c.removeAttribute('id');
        c.removeAttribute('data-hero-slide');
        c.setAttribute('data-hero-clone', '');
        c.setAttribute('aria-hidden', 'true');
        var ided = c.querySelectorAll('[id]');
        for (var k = 0; k < ided.length; k++) ided[k].removeAttribute('id');
        if ('inert' in c) c.inert = true;
        return c;
      }
      var first = slides[0];
      var last = slides[n - 1];
      var cloneFirst = makeClone(first);
      var cloneLast = makeClone(last);
      track.appendChild(cloneFirst);
      track.insertBefore(cloneLast, first);
      // Keep the viewport on the real first slide after prepending — same tick, no flash.
      track.scrollLeft = first.offsetLeft;

      function setActive(i) {
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      }

      function go(i) {
        var target;
        if (i >= n) { target = cloneFirst; index = 0; }
        else if (i < 0) { target = cloneLast; index = n - 1; }
        else { target = slides[i]; index = i; }
        track.scrollTo({ left: target.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        setActive(index);
      }

      // Once scrolling settles on a clone, jump instantly to the matching real slide.
      function settle() {
        var w = track.clientWidth;
        if (!w) return;
        var p = Math.round(track.scrollLeft / w); // 0 = cloneLast … n+1 = cloneFirst
        if (p <= 0) { track.scrollLeft = slides[n - 1].offsetLeft; index = n - 1; }
        else if (p >= n + 1) { track.scrollLeft = slides[0].offsetLeft; index = 0; }
        else { index = p - 1; }
        setActive(index);
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      for (var di = 0; di < dots.length; di++) {
        (function (dot) {
          dot.addEventListener('click', function () { go(parseInt(dot.dataset.index, 10)); });
        })(dots[di]);
      }

      var settleTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 110);
      }, { passive: true });
      if ('onscrollend' in window) {
        track.addEventListener('scrollend', function () { clearTimeout(settleTimer); settle(); });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { track.scrollLeft = slides[index].offsetLeft; }, 150);
      });

      if (hero.dataset.autoplay === 'true' && !reduce) {
        var interval = parseInt(hero.dataset.interval, 10) || 6000;
        var timer = setInterval(function () { go(index + 1); }, interval);
        hero.addEventListener('mouseenter', function () { clearInterval(timer); });
        hero.addEventListener('mouseleave', function () {
          clearInterval(timer);
          timer = setInterval(function () { go(index + 1); }, interval);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Built piecewise so the doubled braces are not parsed as a Liquid tag
    var DEFAULT_MONEY = '$' + '{' + '{amount}' + '}';
    function defaultTo(v, d) { return (v === undefined || v === null) ? d : v; }

    function formatWithDelimiters(cents, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(cents) || cents == null) return '0';
      var number = (cents / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    // Minimal port of Shopify's money formatter so quantity changes can re-price live.
    function formatMoney(cents, format) {
      format = format || DEFAULT_MONEY;
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholder);
      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ''); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return format.replace(placeholder, value);
    }

    function initPdp(root) {
      var moneyFormat = (root.getAttribute('data-money-format') || DEFAULT_MONEY).replace(/<[^>]*>/g, '');

      var variantsEl = root.querySelector('[data-pdp-variants]');
      var hidden = root.querySelector('[data-pdp-variant]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var addBtn = root.querySelector('[data-pdp-add]');
      var addText = root.querySelector('[data-pdp-add-text]');
      var qty = root.querySelector('[data-pdp-qty]');
      var wishBtn = root.querySelector('[data-pdp-wishlist]');
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}

      function clamp(v) { v = parseInt(v, 10); if (isNaN(v) || v < 1) v = 1; return v; }
      function quantity() { return qty ? clamp(qty.value) : 1; }

      var current = variants.filter(function (v) {
        return hidden && String(v.id) === String(hidden.value);
      })[0] || variants[0] || null;

      // Price shown = unit price x quantity, re-formatted on every change.
      function refreshPrice() {
        if (priceEl && current) priceEl.textContent = formatMoney(current.price * quantity(), moneyFormat);
      }

      function selectVariant(variant) {
        if (!variant) return;
        current = variant;
        if (hidden) hidden.value = variant.id;
        if (wishBtn) wishBtn.setAttribute('data-variant', variant.id);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available
            ? (addBtn.getAttribute('data-label-add') || addText.textContent)
            : (addBtn.getAttribute('data-label-sold') || 'SOLD OUT');
        }
        refreshPrice();
      }

      // ---- Gallery dots ----
      var photos = root.querySelectorAll('[data-pdp-photo]');
      var dots = root.querySelectorAll('[data-pdp-dot]');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = dot.getAttribute('data-pdp-dot');
          photos.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pdp-photo') === idx); });
          dots.forEach(function (d) { d.classList.toggle('is-active', d === dot); });
        });
      });

      // ---- Quantity stepper (re-prices on each step) ----
      var minus = root.querySelector('[data-pdp-minus]');
      var plus = root.querySelector('[data-pdp-plus]');
      function setQty(v) { if (qty) { qty.value = Math.max(1, v); refreshPrice(); } }
      if (minus) minus.addEventListener('click', function () { setQty(quantity() - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(quantity() + 1); });
      if (qty) qty.addEventListener('change', function () { setQty(quantity()); });

      // ---- Size -> variant ----
      root.querySelectorAll('[data-pdp-size]').forEach(function (input) {
        input.addEventListener('change', function () {
          var match = variants.filter(function (v) { return v.option1 === input.value; });
          var variant = match.filter(function (v) { return v.available; })[0] || match[0];
          selectVariant(variant);
        });
      });

      // ---- Save to wishlist (localStorage via SymkWishlist) ----
      if (wishBtn) {
        var handle = wishBtn.getAttribute('data-handle');

        function syncWish() {
          if (!window.SymkWishlist || !handle) return;
          var saved = window.SymkWishlist.has(handle);
          wishBtn.classList.toggle('is-saved', saved);
          wishBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
          var label = wishBtn.querySelector('[data-pdp-wishlist-text]');
          if (label) {
            label.textContent = saved
              ? (wishBtn.getAttribute('data-label-saved') || label.textContent)
              : (wishBtn.getAttribute('data-label-save') || label.textContent);
          }
        }

        wishBtn.addEventListener('click', function () {
          if (!window.SymkWishlist || !handle) return;
          window.SymkWishlist.toggle({
            handle: handle,
            variantId: wishBtn.getAttribute('data-variant') || null
          });
        });

        document.addEventListener('symk:wishlist:change', syncWish);
        syncWish();
      }

      refreshPrice();
    }

    function boot() { document.querySelectorAll('[data-symk-pdp]').forEach(initPdp); }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wishlist-root]');
    if (!root) return;

    var listEl = root.querySelector('[data-wishlist-list]');
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    var tmpl = document.querySelector('[data-wishlist-template]');
    if (!listEl || !emptyEl || !tmpl) return;

    var currency = root.getAttribute('data-currency') || '';
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cache = {};
    var hasRendered = false;
    var renderedKey = '';

    function keyOf(items) {
      return items
        .map(function (i) { return i.handle; })
        .join(',');
    }

    function money(cents) {
      var amount = (cents || 0) / 100;
      var str = amount.toLocaleString('en-US', {
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
        useGrouping: false
      });
      return currency ? str + ' ' + currency : str;
    }

    function sized(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    function fetchProduct(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch(shopRoot + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { cache[handle] = data; return data; })
        .catch(function () { return null; });
    }

    function variantFor(product, variantId) {
      if (!product || !product.variants || !product.variants.length) return null;
      if (variantId) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
        }
      }
      return product.variants[0];
    }

    function fill(node, entry) {
      var link = node.querySelector('[data-wish-link]');
      link.href = shopRoot + 'products/' + entry.handle;

      fetchProduct(entry.handle).then(function (product) {
        if (!product) return;
        var variant = variantFor(product, entry.variantId);

        link.href = product.url || link.href;

        var img = node.querySelector('[data-wish-image]');
        var imgUrl = product.featured_image || (product.images && product.images[0]);
        if (imgUrl) {
          img.src = sized(imgUrl, 400);
          img.alt = product.title || '';
        }

        node.querySelector('[data-wish-type]').textContent = (product.type || '').toUpperCase();
        node.querySelector('[data-wish-title]').textContent = (product.title || '').toUpperCase();

        var sizeEl = node.querySelector('[data-wish-size]');
        var size = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
        if (size) {
          sizeEl.textContent = 'SIZE: ' + size;
          sizeEl.hidden = false;
        }

        var price = variant ? variant.price : product.price;
        node.querySelector('[data-wish-price]').textContent = money(price);
      });
    }

    function buildItem(entry) {
      var node = tmpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-handle', entry.handle);

      var countEl = node.querySelector('[data-wish-count]');
      countEl.textContent = entry.qty > 0 ? entry.qty : 1;

      function step(delta) {
        var q = Math.max(1, (parseInt(countEl.textContent, 10) || 1) + delta);
        countEl.textContent = q;
        if (window.SymkWishlist) window.SymkWishlist.setQty(entry.handle, q);
      }
      node.querySelector('[data-wish-dec]').addEventListener('click', function () { step(-1); });
      node.querySelector('[data-wish-inc]').addEventListener('click', function () { step(1); });
      node.querySelector('[data-wish-remove]').addEventListener('click', function () {
        if (window.SymkWishlist) window.SymkWishlist.remove(entry.handle);
      });

      fill(node, entry);
      return node;
    }

    function render(items) {
      renderedKey = keyOf(items);
      listEl.innerHTML = '';

      if (!items.length) {
        emptyEl.hidden = false;
        listEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      listEl.hidden = false;
      var frag = document.createDocumentFragment();
      items.forEach(function (entry) { frag.appendChild(buildItem(entry)); });
      listEl.appendChild(frag);
    }

    // Re-render only when the set of saved products changes; quantity-only
    // updates keep their existing DOM (and focus).
    function maybeRender(items) {
      if (!hasRendered) {
        hasRendered = true;
        render(items);
      } else if (keyOf(items) !== renderedKey) {
        render(items);
      }
    }

    document.addEventListener('symk:wishlist:change', function (e) {
      var items = (e.detail && e.detail.items) || (window.SymkWishlist ? window.SymkWishlist.items() : []);
      maybeRender(items);
    });

    if (window.SymkWishlist) maybeRender(window.SymkWishlist.items());
  })();

  } catch(e) { console.error(e); }
})();
})();
